export const host = '18.163.186.251'
// export const host = 'ec2-18-163-186-251.ap-east-1.compute.amazonaws.com'
// export const host = window.location.host